<div class="input-field" #inputField>
    <input
        name="displayDate"
        [(ngModel)]="displayDate"
        pInputText
        [placeholder]="placeholder"
        (ngModelChange)="onChange($event)"
        oninput="this.value = this.value.replace(/[^0-9.-\s]/g, '')"
    />
    @if (!displayDate) {
        <button (click)="toggleCalendar($event, inputField)" aria-label="Kalender öffnen">
            <img src="assets/icons/input-calendar.svg" />
        </button>
    } @else {
        <button (click)="clearDate()">
            <i class="pi pi-times" aria-label="Datumseingabe löschen"></i>
        </button>
    }
</div>
<p-popover #singleDateCalendarPanel [dismissable]="true" (onShow)="onPopoverShow()">
    <ng-template #content>
        <p-datePicker
            dateFormat="dd.mm.yyyy"
            [inline]="true"
            (onSelect)="onDateSelected($event)"
            [maxDate]="maxDate"
            [minDate]="minDate"
        >
        </p-datePicker>
    </ng-template>
</p-popover>
